import { Injectable } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { createEffect, ofType, Actions } from "@ngrx/effects"
import { Store } from "@ngrx/store"
import { TranslateService } from "@ngx-translate/core"
import { switchMap, tap } from "rxjs"
import { boardStructureReset, boardStructureModified } from "../board-structure/board-structure.actions"
import { SnackbarNotificationService } from "../ui-kit/notifications/snackbar-notification/snackbar-notification.service"

@Injectable()
export class BoardStructureActionsEffects {

    readonly notifyBoardStructureReset$ = createEffect(() =>
        this.actions$.pipe(
            ofType(boardStructureReset),
            switchMap(() => this.translateService.get('messages.boardStructure.reset')),
            tap((message) => this.snackbarNotificationService.openSuccess(message)),
        ), { dispatch: false }
    )

    readonly notifyBoardStructureModified$ = createEffect(() =>
        this.actions$.pipe(
            ofType(boardStructureModified),
            switchMap(() => this.translateService.get('messages.boardStructure.modified')),
            tap((message) => this.snackbarNotificationService.openSuccess(message)),
        ), { dispatch: false }
    )

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly translateService: TranslateService,
        private readonly snackbarNotificationService: SnackbarNotificationService,
        private readonly matDialog: MatDialog
    ) { }
}